import { BBBLogo as s } from "./index2.js";
import { LogoWithHtmlContent as n } from "./index3.js";
class g {
  config;
  constructor(o) {
    this.config = o;
  }
  createLogoBBB() {
    const { showBBB: o, BBB_URL: t, BBB_Image: e, BBB_Title: r } = this.config;
    return new s(o, t, e, r);
  }
  createLogoPCI() {
    const { showTrustwave: o, trustwaveLogoCode: t } = this.config;
    return new n(o, t);
  }
  createLogoSSL() {
    const { siteSeal_Type: o, symantecLogoCode: t, showSiteSeal: e } = this.config;
    return new n(
      e && o === "Symantec",
      t
    );
  }
}
export {
  g as SiteConfigTrustLogosFactory
};
//# sourceMappingURL=index4.js.map
